// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__I7nJa","content":"Footer_content__3jTaz","image":"Footer_image__+qbm9","text":"Footer_text__XWF5p"};